/**
 * This helper checks whether a value contains every attributes of a type T.
 *
 * @param value Any value of type T to be checked
 * @returns true or false
 */
export function isType<T>(value: object): boolean {
  return Object.keys(value).every((x: any): x is T => {
    return value.hasOwnProperty(x);
  });
}
